import { useState, useEffect } from 'react';
import { useAuth } from "../contexts/auth";
import { logout } from "../reducers/auth";
import { setAuthentication } from "../utils/localStorage";

const useLogout = () => {
    const { authDispatch } = useAuth();
    const [ loggingOut, setLoggingOut ] = useState(false);


    useEffect(() => {

        if (loggingOut) {
            
            setAuthentication('');
            authDispatch(logout());
        }
    }, [loggingOut]);

    return { setLoggingOut };
}

export default useLogout;
